/**
 * Paski informacyjne, które można konfigurować w panelu.
 * https://nazwa+sklepu.iai-shop.com/panel/info-bars.php
 */
function Bars() {
    /**
     * Ustalenie wysokości na której pasek będzie podwieszony
     * @param {Array} array - tablica elementów, które mają być podwieszone
     * @param {Int} index - numer porządkowy (indeks) elementu dla którego ma być wyliczona pozycja
     * @returns {Int} - pozycja od góry/dołu podczas podwieszenia
     */
    this.calculatePosition = (array, index) => array.reduce((acc, curr, i) => (i < index
      ? acc + curr.offsetHeight
      : acc), 0);
  
  
    /**
     * Zamknięcie paska po kliknięciu 'X'
     * @param {Event} e - określenie, w który pasek kliknięto
     */
    this.closeBarClick = (e) => {
      const { target } = e;
      if (target.closest('.bars__close')) {
        e.preventDefault();
        const barElement = target.closest('.bars__item');
        barElement.parentNode.removeChild(barElement);
        this.saveClosing(barElement);
        this.reset();
      }
    };
  
    /* Odczytanie z localStorage, które paski zostały wcześniej zamknięte oraz ich usunięcie */
    this.removeClosedBars = () => {
      const closedBars = JSON.parse(localStorage.getItem('closedBars')) || [];
      closedBars.forEach((el) => {
        const bar = document.getElementById(el);
        if (bar) bar.parentNode.removeChild(bar);
      });
      this.checkEmptyBars();
    };
  
    /* Sprawdzenie, czy wszystkie paski są zamknięte, jeżeli tak to usuwany jest wrapper */
    this.checkEmptyBars = () => {
      const topBarsElemnt = document.querySelector('.bars_top');
      if (topBarsElemnt?.childNodes.length === 0) topBarsElemnt.parentNode.removeChild(topBarsElemnt);
      const bottomBarsElemnt = document.querySelector('.bars_bottom');
      if (bottomBarsElemnt?.childNodes.length === 0) bottomBarsElemnt.parentNode.removeChild(bottomBarsElemnt);
    };
  
    /**
     * Zapisanie zamknięcia paska w localStorage
     * @param {Element} bar - pasek, który zamknięto
     */
    this.saveClosing = (bar) => {
      const { id } = bar;
      const closedBars = JSON.parse(localStorage.getItem('closedBars')) || [];
      closedBars.push(id);
      localStorage.setItem('closedBars', JSON.stringify(closedBars));
    };
  
    /* Ustalnie wysokości górnych pasków, aby na mobile odpowiednio odsunąć #layout */
    this.setBarsHeight = () => {
      if (document.documentElement.classList.contains('--scroll-down')) return false;
      const topBarsHeight = document.querySelector('.bars_top')?.offsetHeight ? document.querySelector('.bars_top')?.offsetHeight : 0;
      document.documentElement.style.setProperty('--bars-height', `${topBarsHeight}px`);
      return true;
    };
  
    /* Usunięcie klas oraz atrybutów z podwieszonych pasków */
    this.clearAll = () => {
      const fixedBars = document.querySelectorAll('.bars__item[data-fixed]');
      fixedBars.forEach((el) => {
        el.classList.remove('--fixed');
        el.style.removeProperty('--position');
        el.style.removeProperty('min-height');
      });
    };
  
    /* Usunięcie wszyskich eventów oraz wyczyszczenie podwieszonych pasków */
    this.destroy = () => {
      document.removeEventListener('scroll', this.fixed);
      document.removeEventListener('click', this.closeBarClick);
      window.removeEventListener('resize', this.setBarsHeight);
      this.clearAll();
    };
  
    /* Ponowne odpalenie pasków */
    this.reset = () => {
      this.destroy();
      this.init();
    };
  
    /* Uruchomienie skryptów obsługujących paski */
    this.init = () => {
      this.removeClosedBars();
      document.addEventListener('click', this.closeBarClick);
      if (App.vars.view < 3) {
        this.setBarsHeight();
        window.addEventListener('resize', this.setBarsHeight);
      }
    };
  }
  
  export default Bars;